import { render } from "./PermissionAction.vue?vue&type=template&id=67e470c2&scoped=true"
import script from "./PermissionAction.vue?vue&type=script&lang=js"
export * from "./PermissionAction.vue?vue&type=script&lang=js"

import "./PermissionAction.vue?vue&type=style&index=0&id=67e470c2&scoped=true&lang=css"

import exportComponent from "D:\\laragon\\www\\subeasy\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e470c2"]])

export default __exports__